/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './hotel-brand.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../navbar/navbar.component.ngfactory';
import * as i3 from '../../../../../../../../app/components/navbar/navbar.component';
import * as i4 from '@angular/router';
import * as i5 from '../../../../../../../../app/shared/_services/login.service';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from '../../../../../../../../app/shared/_services/hca-user-management.service';
import * as i8 from '../../../../../../../../app/shared/_services/util.service';
import * as i9 from '../../../../../../../../app/components/admin/hca-admin/hotels/hotel-management/hotel-brand/hotel-brand.component';
const styles_HotelBrandComponent:any[] = [i0.styles];
export const RenderType_HotelBrandComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HotelBrandComponent,data:{}});
export function View_HotelBrandComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_NavbarComponent_0,
      i2.RenderType_NavbarComponent)),i1.ɵdid(1,114688,(null as any),0,i3.NavbarComponent,
      [i4.Router,i5.LoginService,i6.TranslateService,i7.HcaUserManagementService,i8.UtilService],
      (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(3,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
    _ck(_v,4,0);
  },(null as any));
}
export function View_HotelBrandComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-hotel-brand',
      ([] as any[]),(null as any),(null as any),(null as any),View_HotelBrandComponent_0,
      RenderType_HotelBrandComponent)),i1.ɵdid(1,114688,(null as any),0,i9.HotelBrandComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HotelBrandComponentNgFactory:i1.ComponentFactory<i9.HotelBrandComponent> = i1.ɵccf('app-hotel-brand',
    i9.HotelBrandComponent,View_HotelBrandComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL2hvdGVscy9ob3RlbC1tYW5hZ2VtZW50L2hvdGVsLWJyYW5kL2hvdGVsLWJyYW5kLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9ob3RlbHMvaG90ZWwtbWFuYWdlbWVudC9ob3RlbC1icmFuZC9ob3RlbC1icmFuZC5jb21wb25lbnQudHMiLCJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9ob3RlbHMvaG90ZWwtbWFuYWdlbWVudC9ob3RlbC1icmFuZC9ob3RlbC1icmFuZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL2hvdGVscy9ob3RlbC1tYW5hZ2VtZW50L2hvdGVsLWJyYW5kL2hvdGVsLWJyYW5kLmNvbXBvbmVudC50cy5Ib3RlbEJyYW5kQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1uYXZiYXI+PC9hcHAtbmF2YmFyPlxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiIsIjxhcHAtaG90ZWwtYnJhbmQ+PC9hcHAtaG90ZWwtYnJhbmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtNQUFBLDZCQUF5QiwwQ0FDekI7YUFBQTtVQUFBO2FBQUE7MERBQUE7VUFBQTtJQURBO0lBQ0E7Ozs7b0JDREE7TUFBQTtvQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/hca-admin/hotels/hotel-management/hotel-brand/hotel-brand.component.ngfactory.ts